import React, { useEffect, useState } from 'react'
import { fetchBadgeInfo, Achievement } from '../../Api'
import {
  DEFAULT_BADGE_USER,
  HelmetHuntCommunityAchievement,
} from '../../Constants/achievements'
import { Img } from '../Image/Img'
import { MultiLevelProgress } from './MultiLevelProgress'
import { CommunityBadgeAchCon } from './styles'
import { AchievementInfo } from './AchievementInfo'

type CommunityBadgeAchievementProps = {
  badgeId: string
  progressTitle: string
  showActionBtn: boolean
  achImg?: string
  btnText?: string
  
}

export const CommunityBadgeAchievement: React.FC<CommunityBadgeAchievementProps> = ({
  badgeId,
  showActionBtn,
  achImg,
  progressTitle,
  btnText,
}) => {
  const [achievementBadgeInfo, setAchievementBadgeInfo] = useState<Achievement | null>(
    null
  )
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    setupCommunityBadgeAchievement()
  }, [badgeId])

  const setupCommunityBadgeAchievement = async () => {
    try {
      const badgeData = await fetchBadgeInfo(DEFAULT_BADGE_USER, badgeId)
      if (!badgeData) return null
      let helmetHuntAch = HelmetHuntCommunityAchievement
      helmetHuntAch.userProgress = badgeData?.totalOwners || 0
      setAchievementBadgeInfo(helmetHuntAch)
      setLoading(false)
      return
    } catch (err) {
      console.error('Error fetching badge info', err)
      setLoading(false)
      return null
    }
  }

  return (
    <>
      {!loading && (
        <CommunityBadgeAchCon>
          {achImg && (
            <div className="communityFeaturedImgCon">
              <Img
                className="communityFeaturedImg"
                src={achImg}
                alt={'Community achievement Featured image'}
              />
            </div>
          )}
          {achievementBadgeInfo && (
            <div className="achItemCon">
              <AchievementInfo
                progress={achievementBadgeInfo.userProgress}
                progressTitle={progressTitle}
                link={achievementBadgeInfo.link}
                btnText={btnText}
                showActionBtn={showActionBtn}
              />
              <MultiLevelProgress achievement={achievementBadgeInfo} />
            </div>
          )}
        </CommunityBadgeAchCon>
      )}
    </>
  )
}
